     
  $('.search-toggleicon').on('click', function() {
    $(".live-search-form").show();
    $(".live-search").addClass("live-search--takeover");
    $(".live-search").addClass("live-search--focused");
  });


  $('.live-search-takeover-cancel').on('click', function() {
   $(".live-search-form").hide();
  });



//slide to top 
  $(window).scroll(function () {
    if(window.matchMedia('(max-width: 1023px)').matches) {
      if ($(this).scrollTop() > 150) {
        $('.small-promo').slideUp("fast");
        $('.google-ratting').slideUp("fast");
        $('.site-header').addClass("header-scrolled");
      }
      
      
      if ($(this).scrollTop() < 75) {
        $('.small-promo').slideDown("fast");
        $('.google-ratting').slideDown("fast");
        $('.site-header').removeClass("header-scrolled");
      }
    }
  });



  $('.enquire-now-btn').click(function() {
    $('.contactform-popup-overlay').addClass("active");
    $('.page-content-contact').addClass("active");
    $('body').css("overflow", "hidden");
//     document.body.scrollTop = 0; // For Safari
//    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
     
  });
  $('#form_closer').click(function() {
      $('.contactform-popup-overlay').removeClass("active");
      $('.page-content-contact').removeClass("active");
      $('body').css("overflow", "scroll");
  });

  $('.contactform-popup-overlay').click(function() {
      $('.contactform-popup-overlay').removeClass("active");
      $('.page-content-contact').removeClass("active");
      $('body').css("overflow", "scroll");
  });


   var flag = true;
 setInterval(function(){
   if(flag) {
     $(".toggle-delivery").fadeOut("medium");
     $(".toggle-ratting").fadeIn("medium");
     flag = false;
   } else {
     $(".toggle-delivery").fadeIn("medium");
     $(".toggle-ratting").fadeOut("medium");
     flag = true;
   }
 
 }, 4000);

 setTimeout(function(){
   if (isEmpty($('#shopify-section-static-product-recommendations'))) {
      $("#shopify-section-static-product-recommendations").hide();
  }
 
 }, 4000);
 function isEmpty( el ){
      return !$.trim(el.html())
  }
 
  $('#contact_form .form-field-input').focus(function() { 
    $(this).addClass("form-field-filled");
  });
  $('#contact_form .form-field-input').focusout(function() {
    var value = $(this).val();
    if(value == '') {
    $(this).removeClass("form-field-filled");
    }
  });

// $(document).ready(function() {
//    $('.logolist--inner .logolist--item').flickity({
//       freeScroll: true,
//       imagesLoaded: true,
//       draggable: true,
//       cellAlign: 'center',
//       pageDots: false,
//       contain: true,
//       prevNextButtons: true,
//       initialIndex: 0,
//       on: {
//         ready: function ready() {
//           // Resize flickity when the slider is settled
//           $('.product-recommendations .productgrid--item').on('settle.flickity', function () {
//             $('.product-recommendations .productgrid--item').flickity('resize');
//           });
//         }
//       }
//     });
//   });

if(document.querySelector(".read-more1") != null) {
  document.querySelector(".read-more1").addEventListener("click", function() {
    document.querySelector(".readmore_readless1 .collection--description").style.height = "auto";
    document.querySelector(".read-more1").style.display = "none";
    document.querySelector(".read-less1").style.display = "block";
  });

  document.querySelector(".read-less1").addEventListener("click", function() {
    document.querySelector(".readmore_readless1 .collection--description").style.height = "70px";
    document.querySelector(".read-less1").style.display = "none";
    document.querySelector(".read-more1").style.display = "block";
  });
}


  $('.product-linkpdf-inner').click(function() {
    var url = $(this).data('href');
    setCookie('pdfurl',url ,'1'); 
    $('.downloadcontactform-popup-overlay').addClass("active");
    $('.page-content-download').addClass("active");
    $('body').css("overflow", "hidden");
    $('.contact-message').hide();

  });

  if($('.downloadcontactform-popup-overlay').length) {
      const urlParams = new URLSearchParams(window.location.search);
	  const myParam = urlParams.get('contact_posted');
      const myParam1 = urlParams.get('form_type');
    
      if(myParam1 != null) {
        $('.downloadcontactform-popup-overlay').addClass("active");
        $('.page-content-download').addClass("active");
        $('body').css("overflow", "hidden");
      }
    
      if(myParam == 'true') {
         var url =  getCookie('pdfurl');
         window.open(url, '_blank');
        
        var uri = window.location.toString();
        if (uri.indexOf("?") > 0) {
            var clean_uri = uri.substring(0, uri.indexOf("?"));
            window.history.replaceState({}, document.title, clean_uri);
        }
      }
  }



$('.downloadcontactform-popup-overlay').click(function() {
      $('.downloadcontactform-popup-overlay').removeClass("active");
      $('.page-content-download').removeClass("active");
      $('body').css("overflow", "scroll");
  });
$('#downloadform_closer').click(function() {
      $('.downloadcontactform-popup-overlay').removeClass("active");
      $('.page-content-download').removeClass("active");
      $('body').css("overflow", "scroll");
});

function setCookie(key, value, expiry) {
  var expires = new Date();
  expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
  document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
}

function getCookie(key) {
  var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
  return keyValue ? keyValue[2] : null;
}